import { Navigate } from "react-router-dom";

import { getCurrentUser } from "../cognito/cognito";
import adminViews from "../components/admin/adminViews";
import useLoggedInUser from "../providers/logged-in-user/use-logged-in-user";

const RedirectRoute = () => {
  const user = getCurrentUser();
  const { data } = useLoggedInUser();
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  const link = data?.links?.find((l) => !!adminViews[l.rel]);
  if (!link) {
    return <Navigate to="/login" replace />;
  }
  return <Navigate to={`/${link.rel}`} />;
};

export default RedirectRoute;
